import ReactCurrencyInput from "react-currency-input";

let componentDidMount_super = ReactCurrencyInput.prototype.componentDidMount;
ReactCurrencyInput.prototype.componentDidMount = function () {
  if (!this.props.autoFocus) {
    let setSelectionRange_super = this.theInput.setSelectionRange;
    this.theInput.setSelectionRange = () => {};
    componentDidMount_super.call(this, ...arguments);
    this.theInput.setSelectionRange = setSelectionRange_super;
  } else {
    componentDidMount_super.call(this, ...arguments);
  }
};
let componentDidUpdate_super = ReactCurrencyInput.prototype.componentDidUpdate;
ReactCurrencyInput.prototype.componentDidUpdate = function () {
  if (!this.props.autoFocus) {
    let setSelectionRange_super = this.theInput.setSelectionRange;
    this.theInput.setSelectionRange = () => {};
    componentDidUpdate_super.call(this, ...arguments);
    this.theInput.setSelectionRange = setSelectionRange_super;
  } else {
    componentDidMount_super.call(this, ...arguments);
  }
};

export const CurrencyInput = ReactCurrencyInput;
